export default {"src":"/_next/static/media/app-store.840ef5ab.svg","height":100,"width":268};